import { Link, Typography } from '@iheartjane/reefer';

export const DeselectAllButton = ({
  ariaLabel = 'Deselect All',
  onClick,
}: {
  ariaLabel?: string;
  onClick: () => void;
}) => {
  return (
    <Link onClick={onClick}>
      <Typography aria-label={ariaLabel}>Deselect all</Typography>
    </Link>
  );
};
